/*eslint no-undef: 0*/

import 'jquery.easing';
import scrollDisableOnTouch from './touchDeviceScrollPrevent';
import {isTouchDevice} from './util';


/**
 * Mobile hamburger menu
 */
const mobileMenu = () => {
  const navbarToggle = document.querySelector('.js-navbar-toggle');
  const navTarget = document.querySelector('.js-hamburger-menu');

  if (navbarToggle === null) return;

  navbarToggle.addEventListener('click', function (e) {
    e.preventDefault();

    e.currentTarget.classList.toggle('is-expanded');
    navTarget.classList.toggle('is-shown');

    if (e.currentTarget.classList.contains('is-expanded')) {
      e.currentTarget.setAttribute('aria-expanded', true);
      if (isTouchDevice()) scrollDisableOnTouch.init(); // ~ Reference to touch-device-preventPageScroll.js
    } else {
      e.currentTarget.setAttribute('aria-expanded', false);
      if (isTouchDevice())  scrollDisableOnTouch.destroy(); // ~ Reference to touch-device-preventPageScroll.js
    }

    //
    $(document.querySelectorAll('.menu-item-has-children .nav__link')).removeClass('is-active');
    $(document.getElementById('primary-navigation').querySelectorAll('.dropdown-menu'))
      .slideUp({duration: 300, easing: 'easeInQuart'});
  })
};

/**
 * Mobile submenu
 */
const mobileSubmenu = () => {
  [].forEach.call(document.querySelectorAll('.js-dropdown-toggle-caret'), function (elem) {
    elem.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();

      if (!$(this).parent().hasClass('is-active')) {
        $(document.querySelectorAll('.menu-item-has-children > .nav__link')).removeClass('is-active');
        $(document.getElementById('primary-navigation').querySelectorAll('.dropdown-menu'))
          .slideUp({duration: 300, easing: 'easeOutQuad'});
      }
      e.currentTarget.parentNode.classList.toggle('is-active');
      $(e.currentTarget).parent().next()
        .slideToggle({duration: 300, easing: 'easeOutQuad'});
    });
  });
};

export {mobileMenu, mobileSubmenu}



// WEBPACK FOOTER //
// ./scripts/util/navigation.js